import { useSelector } from "react-redux"
import {
  useReplyThreadMutation,
  useUpdateThreadMutation
} from "../../../redux/queries"
import {
  currentThread,
  setCurrentThread
} from "../../../redux/slices/conversations"
import { Thread } from "../../../types"
import { useCallback, useState } from "react"
import { useAppDispatch, useToast } from "../../hooks"

const useConversationChatBox = () => {
  const dispatch = useAppDispatch()
  const { pushErrorToast } = useToast()

  const [message, setReplyMessage] = useState("")

  const thread = useSelector(currentThread) as Thread

  const takeOverFlag = thread?.status === "takeover"

  const updateCurrentThread = useCallback(
    (thread: Thread) => {
      dispatch(setCurrentThread(thread))
    },
    [dispatch]
  )

  const [updateThread] = useUpdateThreadMutation()

  const [replyThread, { isLoading: isSendingReply, isError }] =
    useReplyThreadMutation()

  const handleSendReply = async (message: string) => {
    // dispatch the action to reply to the thread
    await replyThread({ thread_id: thread?._id, message })

    if (isError) {
      pushErrorToast("Failed to send the message, please try again.")
      setReplyMessage(message)
      return
    }

    // update the current thread with the new message
    updateCurrentThread({
      ...thread,
      messages: [
        ...thread.messages,
        {
          _id: Math.random().toString(36).slice(2, 11),
          message,
          sender: "system",
          status: "sent",
          timestamp: new Date().toISOString()
        }
      ]
    })
  }

  const takeOverConversation = () => {
    // dispatch the action to take over the conversation

    const newStatus = takeOverFlag ? "active" : "takeover"

    updateThread({ thread_id: thread?._id, status: newStatus })

    // update the current thread with the new status
    updateCurrentThread({
      ...thread,
      status: newStatus
    })
  }

  const sendReply = () => {
    const msg = message.trim()
    if (msg === "") return
    handleSendReply(msg)
    setReplyMessage("")
  }

  return {
    takeOverFlag,
    takeOverConversation,
    sendReply,
    isSendingReply,
    message,
    setReplyMessage
  }
}

export default useConversationChatBox
